<p-dialog
  [(visible)]="showConfirmStartDateDialog"
  [modal]="true"
  [style]="{ width: '375px' }"
  [header]="'Confirmation'"
  (onHide)="showConfirmStartDateDialogChange.emit(false)"
>
  <div style="margin-bottom: 10px">
    <p>{{ isVME ? 'Deploy route to ' + supplierName : 'Grab route for' }}</p>
    <p style="font-size: 22px">{{ selectedRoute?.price | currency : 'GBP' : 'symbol' }}</p>
    <div *ngIf="routes?.length > 1">
      <p style="font-weight: bold">Select the dates you plan to do the route</p>
      <p-dropdown
        [options]="dateSelectItems"
        [(ngModel)]="selectedRoute"
        appendTo="body"
        (onChange)="onRouteDateChange($event.value)"
      >
      </p-dropdown>
    </div>
  </div>

  <p-footer>
    <button
      type="button"
      pButton
      icon="fa ui-icon-check"
      [label]="isVME ? 'Deploy' : 'Grab Route'"
      class="ui-button-primary"
      (click)="grabOrDeployClicked.emit()"
    ></button>
  </p-footer>
</p-dialog>
